import { useContext } from "react";
import { notification } from "antd";
import { useSetRecoilState } from "recoil";
import { useNavigate } from "react-router";
import authAtom from "../../atoms/auth/auth.atom";
import { handleResponse, postFormRquests, postRequest } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import { useMutation } from "react-query";


export function useConfirm(successAction) {
  const url = "/api/auth/login";
  const axios = useContext(AxiosContext);
  // return useMutation((payload) => successAction?.(), {
    return useMutation((payload) => postRequest(axios, url, payload), {
    onSuccess: (response) => {
      handleResponse(
        response,
        () => {
          notification.success({ message: "Success!", description: response?.message || "welcome back." })
          successAction?.()
        }
      )
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useLogin() {
  const url = "/AdminAuth/SignIn";
  const navigate = useNavigate()
  const axios = useContext(AxiosContext);
  const setAuth = useSetRecoilState(authAtom)
  // return useMutation((payload) => 
  // {setAuth( {isLoggedIn: true}) 
  // navigate("/")}, {
    return useMutation((payload) => postRequest(axios, url, payload), {
    onSuccess: (response) => {
      handleResponse(
        response,
        () => {
          const isSubExpire = response.data.userType === "InsuranceCompany" && (!response?.data?.subscriptionProfile || response?.data?.subscriptionProfile?.isExpired)
          notification.success({ message: "Success!", description: response?.message || "welcome back." })
          setAuth({ isLoggedIn: true, user: response?.data, data: response?.data, res: response, isSubExpire })
          navigate("/")
        }
      )
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useForgot() {
  const url = "/api/admin/auth/forgot-password";
  const navigate = useNavigate()
  const axios = useContext(AxiosContext);
  return useMutation((payload) => postRequest(axios, url, payload), {
    onSuccess: (response) => {
      notification.success({ message: "Success!", description: response?.message || "request sent." })
      navigate(`/auth/confirm?email=${sessionStorage.getItem("forgot-data")}`)
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePostInsurance(successAction) { // //api/v1/Insurance/CreateInsuranceAccount
  const url = "/Insurance/CreateInsuranceAccount"; 
  const axios = useContext(AxiosContext);
  return useMutation((payload) => postFormRquests(url, payload), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useReset() {
  const url = "/api/admin/auth/forgot-password";
  const navigate = useNavigate()
  const axios = useContext(AxiosContext);
  return useMutation((payload) => postRequest(axios, url, payload), {
    onSuccess: (response) => {
      notification.success({ message: "Success!", description: response?.message || "your password has been reset." })
      navigate("/auth/login")
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}
